#!/usr/bin/env node

const processIconSets = require('./processIconSets');
const optimize = require('./optimize');


optimize().then(() => {
    processIconSets();

    console.log("SVGs optimized and components generated.")
});
